import urls from "../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../utils/service";

export const generatePromo = async (accessType: string, number: number) => {
  try {
    const callParams = await getCallParams("PUT", { accessType, number });
    const response = await makeCall(urls.promocode, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const validatePromoCode = async (promo: string) => {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.promocode}/${promo}`, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
